module.exports = __webpack_public_path__ + "static/services-img11-5420e820b273c770f602550d77e8a2fc.png";